import { SearchFilterOption } from "../../../shared/components/search-bar/search-filter/search-filter.component";
import { SearchInputOption } from "../../../shared/components/search-bar/search-input/search-input.component";
import { UserInfo } from "../../../shared/types/user-info";
import { Partner } from "./partner.type";

//#region Search Filter Options

export const getPartnerSearchFilterOptions = (
  user: UserInfo,
  config?: {
    shown?: string[];
    hidden?: string[];
  },
): SearchFilterOption<Partner>[] => {
  const { shown, hidden } = config || {};

  return (
    [
      { value: "name", label: "Name" },
      {
        value: "partnerIdentifier",
        label: "Partner ID",
      },
      {
        value: "type",
        label: "Type",

        inputType: "dropdown",
        options: [...partnerTypes],
        condition: "$eq",
      },
      {
        value: "status",
        label: "Status",

        inputType: "dropdown",
        options: [...partnerStatuses],
        condition: "$eq",
      },
    ] as SearchFilterOption<Partner>[]
  ).filter((opt) => (shown ? shown.includes(opt.value) : true) && (hidden ? !hidden.includes(opt.value) : true));
};

//#endregion

//#region Search Input Options

export const partnerTypes: SearchInputOption[] = [
  { value: "backend provider", label: "Backend Provider" },
  { value: "broker", label: "Broker" },
  { value: "cloud", label: "Cloud" },
  { value: "distributor", label: "Distributor" },
  { value: "itad", label: "ITAD" },
  { value: "msp", label: "MSP" },
  { value: "oem", label: "OEM" },
  { value: "service provider", label: "Service Provider" },
  { value: "var", label: "VAR" },
];

export const partnerStatuses: SearchInputOption[] = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

//#endregion

export const partnerSearchFilterOptions: SearchFilterOption[] = [
  { value: "name", label: "Name" },
  {
    value: "type",
    label: "Type",

    inputType: "dropdown",
    options: [...partnerTypes],
    condition: "$eq",
  },
  {
    value: "status",
    label: "Status",

    inputType: "dropdown",
    options: [...partnerStatuses],
    condition: "$eq",
  },
  {
    value: "partnerIdentifier",
    label: "Partner ID",
  },
];
